import React from 'react'
import { withOnlyPE } from '../../Device'
import { ONE_SECOND_MS } from '../../utils/date'
import AdVideo from '../../advertising/AdVideo'
import DelayComponent from '../../utils/DelayComponent'

const DELAY_BEFORE_LAUNCH = ONE_SECOND_MS

const ItineraryResultAdVideo = () => (
  <DelayComponent delay={DELAY_BEFORE_LAUNCH}>
    <AdVideo />
  </DelayComponent>
)

export default withOnlyPE(ItineraryResultAdVideo)
